var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "175px",
    height: "175px",
    viewBox: "0 0 175 175",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1890FF",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5,162.5 C46.08125,162.5 12.5,128.91875 12.5,87.5 C12.5,46.08125 46.08125,12.5 87.5,12.5 C128.91875,12.5 162.5,46.08125 162.5,87.5 C162.5,128.91875 128.91875,162.5 87.5,162.5 M87.5,0 C39.25,0 0,39.25 0,87.5 C0,135.75 39.25,175 87.5,175 C135.75,175 175,135.75 175,87.5 C175,39.25 135.75,0 87.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.25,137.5 L93.75,137.5 L93.75,81.25 L81.25,81.25 L81.25,137.5 Z M87.5,40.625 C82.3223305,40.625 78.125,44.8223305 78.125,50 C78.125,55.1776695 82.3223305,59.375 87.5,59.375 C92.6776695,59.375 96.875,55.1776695 96.875,50 C96.875,44.8223305 92.6776695,40.625 87.5,40.625"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.05421030731214afa1122e889f5f2dd1.svg";
export { ForwardRef as ReactComponent };